// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"dcd7f235","990":"ef174e45"}[chunkId] + ".chunk.css";
};